import { $bi } from 'bi-base'
import qs from 'qs'
import { getCookie } from '@/utils'
const request = {
  fulfilled: (config = {}) => {
    if (config.method === 'get') {
      config.paramsSerializer = params => {
        return qs.stringify(params, {
            arrayFormat: 'repeat',
            encode: true
          })
      }
      config.paramsSerializer.indexes = null
    }
    // 因為包war的container的proxy元件更改cookie名稱，故特別以此取得cookie的XSRF-TOKEN
    // 本機開發購過vue proxy不需做此處裡
    // https://www.wjsljc.com/document/ts-axios/axios/chapter8/xsrf.html
    let xsrft = getCookie('!Proxy!RestApiProxyXSRF-TOKEN')
    if (xsrft) { // 有取到XSRF-TOKEN再轉成X-XSRF-TOKEN放入key
      config.headers['X-XSRF-TOKEN'] = xsrft
    }
    return config
  },
  rejected: error => {
    $bi.error(error)
    return Promise.reject(error)
  }
}
export default request
